import { render, staticRenderFns } from "./exhaleCount.vue?vue&type=template&id=ca39b898&scoped=true&"
import script from "./exhaleCount.vue?vue&type=script&lang=js&"
export * from "./exhaleCount.vue?vue&type=script&lang=js&"
import style0 from "./exhaleCount.vue?vue&type=style&index=0&id=ca39b898&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca39b898",
  null
  
)

export default component.exports